/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S3_Li3Inputs */

const tr_onbilgi_s3_li3 = /** @type {(inputs: Onbilgi_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçilen plana ait KDV dahil toplam bedel, varsa mahsup tutarı ve ödenecek fark satın alma ekranında ve ödeme adımında gösterilir; onayladığınız nüsha bu bedellerle doldurulmuş olarak e-posta ile tarafınıza gönderilir.`)
};

const en_onbilgi_s3_li3 = /** @type {(inputs: Onbilgi_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The total price including VAT for the selected plan, any credit amount and the difference payable are shown on the purchase screen and in the payment step; the copy you confirm is sent to you by email with these amounts filled in.`)
};

const de_onbilgi_s3_li3 = /** @type {(inputs: Onbilgi_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Gesamtpreis inklusive Mehrwertsteuer für den gewählten Plan, ein etwaiger Anrechnungsbetrag und der zu zahlende Differenzbetrag werden auf dem Kaufbildschirm und im Zahlungsschritt angezeigt; die von Ihnen bestätigte Ausfertigung wird Ihnen mit diesen Beträgen ausgefüllt per E-Mail zugesandt.`)
};

const ru_onbilgi_s3_li3 = /** @type {(inputs: Onbilgi_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общая стоимость выбранного плана с НДС, сумма зачёта (при наличии) и подлежащая оплате разница отображаются на экране покупки и на шаге оплаты; подтверждённый вами экземпляр направляется вам по электронной почте с заполненными суммами.`)
};

/**
* | output |
* | --- |
* | "The total price including VAT for the selected plan, any credit amount and the difference payable are shown on the purchase screen and in the payment step; t..." |
*
* @param {Onbilgi_S3_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s3_li3 = /** @type {((inputs?: Onbilgi_S3_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S3_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s3_li3(inputs)
	if (locale === "de") return de_onbilgi_s3_li3(inputs)
	if (locale === "ru") return ru_onbilgi_s3_li3(inputs)
	return tr_onbilgi_s3_li3(inputs)
});